export default __webpack_public_path__ + "static/media/Digistore_Logo_LQ_2.e166c14d.png";